import { PersonAdd } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getResponsables } from "../../../../redux/actions/empleador";
import { StyledResponsableDialog } from "../../../styled/Responsables";
import FormikActions from "../../formik/FormikActions";
import FormikAutocomplete from "../../formik/FormikAutocomplete";
import CircularLoading from "../../loading/CircularLoading";

const initialValues = {
  id: "",
  nombre: "",
  cuit: "",
};

const validationSchema = Yup.object({
  id: Yup.number().required("Campo obligatorio"),
});

const AddResponsableDialog = ({
  open,
  handleClose,
  handleSubmit,
  handleOpenNewResponsable,
  openInNewResponsable,
}) => {
  const dispatch = useDispatch();

  const responsablesRedux = useSelector((state) => state.empleador.responsables);

  const [formModel, setFormModel] = useState(null);

  useEffect(() => {
    if (openInNewResponsable) {
      const responsable =
        responsablesRedux.data[responsablesRedux.data.length - 1];
      setFormModel({
        ...initialValues,
        id: responsable.id,
        nombre: responsable.nombre.split("(")[0],
        cuit: responsable.nombre
          .split(" - ")[0]
          .split("(")[1]
          .replaceAll(")", ""),
      });
    } else {
      setFormModel({ ...initialValues });
    }
  }, [openInNewResponsable]);

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>Seleccionar Responsable</DialogTitle>
      <Formik
        initialValues={formModel}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form>
            {!isSubmitting ? (
              <>
                <DialogContent>
                  <StyledResponsableDialog.RowContainer>
                    <StyledResponsableDialog.InputContainer>

                      <FormikAutocomplete
                        name="id"
                        label="Responsables"
                        options={responsablesRedux.data}
                        renderOption={(option) => option.nombre}
                        filterOptions={(option) => option.nombre}
                        getOptions={() => dispatch(getResponsables())}
                        callBack={(value) => {
                          if (value) {
                            setFieldValue("nombre", value.nombre.split("(")[0]);
                            setFieldValue(
                              "cuit",
                              /\(([^)]+)\)/
                                .exec(value.nombre.split(" - ")[0])[1]
                                .replaceAll("-", "")
                            );
                          }
                        }}
                      />
                    </StyledResponsableDialog.InputContainer>
                  </StyledResponsableDialog.RowContainer>
                </DialogContent>
                <DialogActions>
                  <FormikActions handleCancel={handleClose}></FormikActions>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleOpenNewResponsable}
                    endIcon={<PersonAdd />}
                  >
                    Nuevo
                  </Button>
                </DialogActions>
              </>
            ) : (
              <StyledResponsableDialog.DialogContainer>
                <CircularLoading />
              </StyledResponsableDialog.DialogContainer>
            )}
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddResponsableDialog;
